import { Space } from 'antd';
import type * as React from 'react';
import styled from 'styled-components';

const StyledSpace = styled(Space)`
  line-height: 1;
`;

export interface IUserNameProps {
  name?: string | null;
  tag?: React.ReactNode;
  icon?: React.ReactNode;
  sendDate?: React.ReactNode;
  registrationDate?: React.ReactNode;
  protocolNumber?: React.ReactNode;
  hasProtocol?: boolean;
  /** Stato di lettura della comunicazione da parte del destinatario */
  readState?: React.ReactNode;
}

/**
 * Nome utente comunicazione (mittente/destinatario) con eventuale suffisso
 */
export function UserName(props: IUserNameProps) {
  const {
    name,
    tag,
    icon,
    registrationDate,
    protocolNumber,
    hasProtocol,
    sendDate,
    readState,
  } = props;

  return (
    <StyledSpace size={4} align="baseline" wrap>
      {icon}
      {name}
      {tag}
      {sendDate}
      {registrationDate}
      {protocolNumber}
      {readState}
    </StyledSpace>
  );
}
